import { Injectable } from '@angular/core'
import { Location } from '@angular/common'
import { Router, NavigationEnd } from '@angular/router'
import { BehaviorSubject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private history: string[] = []
  private canGoBackSubject = new BehaviorSubject<boolean>(false)
  readonly canGoBack$ = this.canGoBackSubject.asObservable()

  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const current = event.urlAfterRedirects
        const last = this.history[this.history.length - 1]
        if (last !== current) {
          this.history.push(current)
        }
        this.canGoBackSubject.next(this.history.length > 1)
      }
    })
  }

  back(): void {
    if (this.history.length > 1) {
      this.history.pop()
      this.location.back()
    } else {
      this.router.navigateByUrl('/home')
    }
    this.canGoBackSubject.next(this.history.length > 1)
  }
}
